import { css } from '@emotion/react';

export default css({
  '&.brand-routes-wrapper': {
    height: '100%',
    flexDirection: 'column',
  },
});
